/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Block = {
  __typename?: 'Block';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Span>>>;
  level?: Maybe<Scalars['Float']>;
  listItem?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
};

export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type CrossDatasetReference = {
  __typename?: 'CrossDatasetReference';
  _dataset?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _projectId?: Maybe<Scalars['String']>;
  _ref?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _weak?: Maybe<Scalars['Boolean']>;
};

export type CrossDatasetReferenceFilter = {
  _dataset?: InputMaybe<StringFilter>;
  _key?: InputMaybe<StringFilter>;
  _projectId?: InputMaybe<StringFilter>;
  _ref?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _weak?: InputMaybe<BooleanFilter>;
};

export type CrossDatasetReferenceSorting = {
  _dataset?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _projectId?: InputMaybe<SortOrder>;
  _ref?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _weak?: InputMaybe<SortOrder>;
};

export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Date']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Date']>;
};

export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** A Sanity document */
export type Document = {
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
};

export type DocumentSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
};

export type File = {
  __typename?: 'File';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityFileAsset>;
};

export type FileFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityFileAssetFilter>;
};

export type FileSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};

export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Float']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Float']>;
};

export type Geopoint = {
  __typename?: 'Geopoint';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type GeopointFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  alt?: InputMaybe<FloatFilter>;
  lat?: InputMaybe<FloatFilter>;
  lng?: InputMaybe<FloatFilter>;
};

export type GeopointSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  alt?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};

export type HighlightColor = {
  __typename?: 'HighlightColor';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type HighlightColorFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type HighlightColorSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['ID']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<Scalars['ID']>>;
};

export type Image = {
  __typename?: 'Image';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
};

export type ImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityImageAssetFilter>;
  crop?: InputMaybe<SanityImageCropFilter>;
  hotspot?: InputMaybe<SanityImageHotspotFilter>;
};

export type ImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  crop?: InputMaybe<SanityImageCropSorting>;
  hotspot?: InputMaybe<SanityImageHotspotSorting>;
};

export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Int']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Int']>;
};

export type Link = {
  __typename?: 'Link';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  blank?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type LinkFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  blank?: InputMaybe<BooleanFilter>;
  href?: InputMaybe<StringFilter>;
  linkType?: InputMaybe<FloatFilter>;
  url?: InputMaybe<StringFilter>;
};

export type LinkSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  blank?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  linkType?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type LocationsList = Document & {
  __typename?: 'LocationsList';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  /** Fill in the location code (e.g., AZ for Arizona). */
  code?: Maybe<Scalars['String']>;
  /** The name of the State or location, e.g. Arizona, or Mohegan Reservation. */
  name?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['String']>;
  tvgOnly?: Maybe<Scalars['Boolean']>;
  typeOfLocation?: Maybe<Scalars['String']>;
};

export type LocationsListFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  subtext?: InputMaybe<StringFilter>;
  tvgOnly?: InputMaybe<BooleanFilter>;
  typeOfLocation?: InputMaybe<StringFilter>;
};

export type LocationsListSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  subtext?: InputMaybe<SortOrder>;
  tvgOnly?: InputMaybe<SortOrder>;
  typeOfLocation?: InputMaybe<SortOrder>;
};

export type MediaTag = Document & {
  __typename?: 'MediaTag';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Slug>;
};

export type MediaTagFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  name?: InputMaybe<SlugFilter>;
};

export type MediaTagSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SlugSorting>;
};

export type Menu = Document & {
  __typename?: 'Menu';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  menuItems?: Maybe<Array<Maybe<MenuItem>>>;
  name?: Maybe<Scalars['String']>;
};

export type MenuFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  name?: InputMaybe<StringFilter>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  newWindow?: Maybe<Scalars['Boolean']>;
  submenu?: Maybe<Array<Maybe<MenuItem>>>;
};

export type MenuItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  newWindow?: InputMaybe<BooleanFilter>;
};

export type MenuItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  newWindow?: InputMaybe<SortOrder>;
};

export type MenuSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MkCallToAction = {
  __typename?: 'MkCallToAction';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_backgroundColor?: Maybe<SimplerColor>;
  mk_backgroundImage?: Maybe<Image>;
  mk_callToAction?: Maybe<Scalars['String']>;
  mk_callToActionLink?: Maybe<Scalars['String']>;
  mk_cards?: Maybe<Array<Maybe<MkCallToActionCard>>>;
  mk_headingh1?: Maybe<Scalars['String']>;
  mk_headingh1Color?: Maybe<SimplerColor>;
  mk_lineUnderHeaderColor?: Maybe<SimplerColor>;
  mk_topHtml?: Maybe<Scalars['String']>;
  separatorImage?: Maybe<Image>;
};

export type MkCallToActionCard = {
  __typename?: 'MkCallToActionCard';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bodyText?: Maybe<Scalars['String']>;
  bodyTextColor?: Maybe<SimplerColor>;
  mk_backTextColor?: Maybe<SimplerColor>;
  mk_headingText?: Maybe<Scalars['String']>;
  mk_headingTextColor?: Maybe<SimplerColor>;
  mk_sideImage?: Maybe<Image>;
  /** If filled out, overrides header and body text */
  mk_topHtml?: Maybe<Scalars['String']>;
};

export type MkCallToActionCardFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  bodyText?: InputMaybe<StringFilter>;
  bodyTextColor?: InputMaybe<SimplerColorFilter>;
  mk_backTextColor?: InputMaybe<SimplerColorFilter>;
  mk_headingText?: InputMaybe<StringFilter>;
  mk_headingTextColor?: InputMaybe<SimplerColorFilter>;
  mk_sideImage?: InputMaybe<ImageFilter>;
  mk_topHtml?: InputMaybe<StringFilter>;
};

export type MkCallToActionCardSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  bodyText?: InputMaybe<SortOrder>;
  bodyTextColor?: InputMaybe<SimplerColorSorting>;
  mk_backTextColor?: InputMaybe<SimplerColorSorting>;
  mk_headingText?: InputMaybe<SortOrder>;
  mk_headingTextColor?: InputMaybe<SimplerColorSorting>;
  mk_sideImage?: InputMaybe<ImageSorting>;
  mk_topHtml?: InputMaybe<SortOrder>;
};

export type MkCallToActionFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_backgroundColor?: InputMaybe<SimplerColorFilter>;
  mk_backgroundImage?: InputMaybe<ImageFilter>;
  mk_callToAction?: InputMaybe<StringFilter>;
  mk_callToActionLink?: InputMaybe<StringFilter>;
  mk_headingh1?: InputMaybe<StringFilter>;
  mk_headingh1Color?: InputMaybe<SimplerColorFilter>;
  mk_lineUnderHeaderColor?: InputMaybe<SimplerColorFilter>;
  mk_topHtml?: InputMaybe<StringFilter>;
  separatorImage?: InputMaybe<ImageFilter>;
};

export type MkCallToActionOrMkCarouselHeroOrMkCustomHtmlTemplateOrMkCustomJsTemplateOrMkHeadingOrMkHeroOrMkInfoCardsTemplateOrMkResponsiveBannerOrMkSpacerOrMkWhereCanYouPlayTemplateOrMkWhyFanDuelTemplate = MkCallToAction | MkCarouselHero | MkCustomHtmlTemplate | MkCustomJsTemplate | MkHeading | MkHero | MkInfoCardsTemplate | MkResponsiveBanner | MkSpacer | MkWhereCanYouPlayTemplate | MkWhyFanDuelTemplate;

export type MkCallToActionSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_backgroundColor?: InputMaybe<SimplerColorSorting>;
  mk_backgroundImage?: InputMaybe<ImageSorting>;
  mk_callToAction?: InputMaybe<SortOrder>;
  mk_callToActionLink?: InputMaybe<SortOrder>;
  mk_headingh1?: InputMaybe<SortOrder>;
  mk_headingh1Color?: InputMaybe<SimplerColorSorting>;
  mk_lineUnderHeaderColor?: InputMaybe<SimplerColorSorting>;
  mk_topHtml?: InputMaybe<SortOrder>;
  separatorImage?: InputMaybe<ImageSorting>;
};

export type MkCarouselHero = {
  __typename?: 'MkCarouselHero';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Plays on screens 640px and above when component is first mounted. Compress and host your video on Cloudfront for optimal performance. */
  desktopIntroVideoUrl?: Maybe<Scalars['String']>;
  /** Style of navigation UI and its position. Used for moving between slides on desktop. Hidden when there's only one slide. */
  desktopSlideNavUi?: Maybe<Scalars['String']>;
  /** Plays on screens 639px and below when component is first mounted. Compress and host your video on Cloudfront for optimal performance. */
  mobileIntroVideoUrl?: Maybe<Scalars['String']>;
  /** Style of navigation UI and its position. Used for moving between slides on mobile. Hidden when there's only one slide. Slides are always swipeable. */
  mobileSlideNavUi?: Maybe<Scalars['String']>;
  moduleAnalyticsEventProperty?: Maybe<Scalars['String']>;
  placementAnalyticsEventProperty?: Maybe<Scalars['String']>;
  slides?: Maybe<Array<Maybe<MkCarouselHeroSlide>>>;
  title?: Maybe<Scalars['String']>;
};

export type MkCarouselHeroFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  desktopIntroVideoUrl?: InputMaybe<StringFilter>;
  desktopSlideNavUi?: InputMaybe<StringFilter>;
  mobileIntroVideoUrl?: InputMaybe<StringFilter>;
  mobileSlideNavUi?: InputMaybe<StringFilter>;
  moduleAnalyticsEventProperty?: InputMaybe<StringFilter>;
  placementAnalyticsEventProperty?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MkCarouselHeroSlide = {
  __typename?: 'MkCarouselHeroSlide';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  buttonOneAnalyticsEventName?: Maybe<Scalars['String']>;
  buttonOneProductAnalyticsEventProperty?: Maybe<Scalars['String']>;
  buttonOneText?: Maybe<Scalars['String']>;
  buttonOneUrl?: Maybe<Scalars['String']>;
  buttonTwoAnalyticsEventName?: Maybe<Scalars['String']>;
  buttonTwoProductAnalyticsEventProperty?: Maybe<Scalars['String']>;
  buttonTwoText?: Maybe<Scalars['String']>;
  buttonTwoUrl?: Maybe<Scalars['String']>;
  customProductNameAndLogoImage?: Maybe<Image>;
  desktopBackgroundImage?: Maybe<Image>;
  headline?: Maybe<Scalars['String']>;
  headlineImage?: Maybe<Image>;
  headlineText?: Maybe<Scalars['String']>;
  /** If enabled, slide will not appear in carousel. */
  isHidden?: Maybe<Scalars['Boolean']>;
  mobileBackgroundImage?: Maybe<Image>;
  /** FanDuel logo with product name on upper left of slide OR a custom image. */
  productNameAndLogo?: Maybe<Scalars['String']>;
  sublineDescription?: Maybe<Scalars['String']>;
  sublineHeading?: Maybe<Scalars['String']>;
  tabletBackgroundImage?: Maybe<Image>;
  title?: Maybe<Scalars['String']>;
};

export type MkCarouselHeroSlideFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  buttonOneAnalyticsEventName?: InputMaybe<StringFilter>;
  buttonOneProductAnalyticsEventProperty?: InputMaybe<StringFilter>;
  buttonOneText?: InputMaybe<StringFilter>;
  buttonOneUrl?: InputMaybe<StringFilter>;
  buttonTwoAnalyticsEventName?: InputMaybe<StringFilter>;
  buttonTwoProductAnalyticsEventProperty?: InputMaybe<StringFilter>;
  buttonTwoText?: InputMaybe<StringFilter>;
  buttonTwoUrl?: InputMaybe<StringFilter>;
  customProductNameAndLogoImage?: InputMaybe<ImageFilter>;
  desktopBackgroundImage?: InputMaybe<ImageFilter>;
  headline?: InputMaybe<StringFilter>;
  headlineImage?: InputMaybe<ImageFilter>;
  headlineText?: InputMaybe<StringFilter>;
  isHidden?: InputMaybe<BooleanFilter>;
  mobileBackgroundImage?: InputMaybe<ImageFilter>;
  productNameAndLogo?: InputMaybe<StringFilter>;
  sublineDescription?: InputMaybe<StringFilter>;
  sublineHeading?: InputMaybe<StringFilter>;
  tabletBackgroundImage?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MkCarouselHeroSlideSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  buttonOneAnalyticsEventName?: InputMaybe<SortOrder>;
  buttonOneProductAnalyticsEventProperty?: InputMaybe<SortOrder>;
  buttonOneText?: InputMaybe<SortOrder>;
  buttonOneUrl?: InputMaybe<SortOrder>;
  buttonTwoAnalyticsEventName?: InputMaybe<SortOrder>;
  buttonTwoProductAnalyticsEventProperty?: InputMaybe<SortOrder>;
  buttonTwoText?: InputMaybe<SortOrder>;
  buttonTwoUrl?: InputMaybe<SortOrder>;
  customProductNameAndLogoImage?: InputMaybe<ImageSorting>;
  desktopBackgroundImage?: InputMaybe<ImageSorting>;
  headline?: InputMaybe<SortOrder>;
  headlineImage?: InputMaybe<ImageSorting>;
  headlineText?: InputMaybe<SortOrder>;
  isHidden?: InputMaybe<SortOrder>;
  mobileBackgroundImage?: InputMaybe<ImageSorting>;
  productNameAndLogo?: InputMaybe<SortOrder>;
  sublineDescription?: InputMaybe<SortOrder>;
  sublineHeading?: InputMaybe<SortOrder>;
  tabletBackgroundImage?: InputMaybe<ImageSorting>;
  title?: InputMaybe<SortOrder>;
};

export type MkCarouselHeroSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  desktopIntroVideoUrl?: InputMaybe<SortOrder>;
  desktopSlideNavUi?: InputMaybe<SortOrder>;
  mobileIntroVideoUrl?: InputMaybe<SortOrder>;
  mobileSlideNavUi?: InputMaybe<SortOrder>;
  moduleAnalyticsEventProperty?: InputMaybe<SortOrder>;
  placementAnalyticsEventProperty?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type MkCustomHtmlTemplate = {
  __typename?: 'MkCustomHtmlTemplate';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** All JS will be removed. Must go into Custom JS Component  */
  mk_html?: Maybe<Scalars['String']>;
  mk_title?: Maybe<Scalars['String']>;
};

export type MkCustomHtmlTemplateFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_html?: InputMaybe<StringFilter>;
  mk_title?: InputMaybe<StringFilter>;
};

export type MkCustomHtmlTemplateSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_html?: InputMaybe<SortOrder>;
  mk_title?: InputMaybe<SortOrder>;
};

export type MkCustomJsTemplate = {
  __typename?: 'MkCustomJsTemplate';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_js?: Maybe<Scalars['String']>;
  mk_title?: Maybe<Scalars['String']>;
};

export type MkCustomJsTemplateFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_js?: InputMaybe<StringFilter>;
  mk_title?: InputMaybe<StringFilter>;
};

export type MkCustomJsTemplateSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_js?: InputMaybe<SortOrder>;
  mk_title?: InputMaybe<SortOrder>;
};

export type MkHeading = {
  __typename?: 'MkHeading';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_BackgroundColor?: Maybe<SimplerColor>;
  /** Used to allow navigation to specific sections of the homepage */
  mk_heading_id?: Maybe<Scalars['String']>;
  mk_heading_main?: Maybe<Scalars['String']>;
  mk_heading_mainColor?: Maybe<SimplerColor>;
  mk_heading_sub?: Maybe<Scalars['String']>;
  mk_heading_subColor?: Maybe<SimplerColor>;
};

export type MkHeadingFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_BackgroundColor?: InputMaybe<SimplerColorFilter>;
  mk_heading_id?: InputMaybe<StringFilter>;
  mk_heading_main?: InputMaybe<StringFilter>;
  mk_heading_mainColor?: InputMaybe<SimplerColorFilter>;
  mk_heading_sub?: InputMaybe<StringFilter>;
  mk_heading_subColor?: InputMaybe<SimplerColorFilter>;
};

export type MkHeadingSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_BackgroundColor?: InputMaybe<SimplerColorSorting>;
  mk_heading_id?: InputMaybe<SortOrder>;
  mk_heading_main?: InputMaybe<SortOrder>;
  mk_heading_mainColor?: InputMaybe<SimplerColorSorting>;
  mk_heading_sub?: InputMaybe<SortOrder>;
  mk_heading_subColor?: InputMaybe<SimplerColorSorting>;
};

export type MkHero = {
  __typename?: 'MkHero';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_backgroundImage?: Maybe<Image>;
  mk_bottomText?: Maybe<Scalars['String']>;
  mk_callToAction?: Maybe<Scalars['String']>;
  mk_callToActionLink?: Maybe<Scalars['String']>;
  mk_frontImage?: Maybe<Image>;
  mk_headingh1?: Maybe<Scalars['String']>;
  mk_headingh2?: Maybe<Scalars['String']>;
  mk_tagline?: Maybe<Scalars['String']>;
  mk_topHtml?: Maybe<Scalars['String']>;
};

export type MkHeroFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_backgroundImage?: InputMaybe<ImageFilter>;
  mk_bottomText?: InputMaybe<StringFilter>;
  mk_callToAction?: InputMaybe<StringFilter>;
  mk_callToActionLink?: InputMaybe<StringFilter>;
  mk_frontImage?: InputMaybe<ImageFilter>;
  mk_headingh1?: InputMaybe<StringFilter>;
  mk_headingh2?: InputMaybe<StringFilter>;
  mk_tagline?: InputMaybe<StringFilter>;
  mk_topHtml?: InputMaybe<StringFilter>;
};

export type MkHeroSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_backgroundImage?: InputMaybe<ImageSorting>;
  mk_bottomText?: InputMaybe<SortOrder>;
  mk_callToAction?: InputMaybe<SortOrder>;
  mk_callToActionLink?: InputMaybe<SortOrder>;
  mk_frontImage?: InputMaybe<ImageSorting>;
  mk_headingh1?: InputMaybe<SortOrder>;
  mk_headingh2?: InputMaybe<SortOrder>;
  mk_tagline?: InputMaybe<SortOrder>;
  mk_topHtml?: InputMaybe<SortOrder>;
};

export type MkHomePage = Document & {
  __typename?: 'MkHomePage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  mk_footer?: Maybe<Scalars['Boolean']>;
  mk_header?: Maybe<Scalars['String']>;
  mk_pageBuilder?: Maybe<Array<Maybe<MkCallToActionOrMkCarouselHeroOrMkCustomHtmlTemplateOrMkCustomJsTemplateOrMkHeadingOrMkHeroOrMkInfoCardsTemplateOrMkResponsiveBannerOrMkSpacerOrMkWhereCanYouPlayTemplateOrMkWhyFanDuelTemplate>>>;
  mk_seo?: Maybe<Seo>;
  mk_title?: Maybe<Scalars['String']>;
};

export type MkHomePageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  mk_footer?: InputMaybe<BooleanFilter>;
  mk_header?: InputMaybe<StringFilter>;
  mk_seo?: InputMaybe<SeoFilter>;
  mk_title?: InputMaybe<StringFilter>;
};

export type MkHomePageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  mk_footer?: InputMaybe<SortOrder>;
  mk_header?: InputMaybe<SortOrder>;
  mk_seo?: InputMaybe<SeoSorting>;
  mk_title?: InputMaybe<SortOrder>;
};

export type MkInfoCard = {
  __typename?: 'MkInfoCard';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  cardLinkAnalyticsEventName?: Maybe<Scalars['String']>;
  cardProductAnalyticsEventProperty?: Maybe<Scalars['String']>;
  exploreItemContentMaxWidth?: Maybe<Scalars['String']>;
  /** Opacity of the overlay. Lower values (e.g., 0.1) represent lighter opacities, making the overlay barely visible, while higher values (e.g., 1) indicate fully opaque overlays, completely blocking the content behind them. */
  mk_OverlayOpacity?: Maybe<Scalars['Float']>;
  mk_OverlayOpacityColor?: Maybe<SimplerColor>;
  /** If a value is provided for this link, it will override the destination for all other links within the card component. This means that if 'mk_cardLink' is set, it will become the primary link for the entire card, superseding any other links present. */
  mk_cardLink?: Maybe<Scalars['String']>;
  /** Span for large screens (1024px). Enter 1-12. E.g., 3 = 1/4 width, 6 = 1/2 width. */
  mk_grid_span_lg?: Maybe<Scalars['Float']>;
  /** Span for medium screens (960px). Enter 1-12. E.g., 3 = 1/4 width, 6 = 1/2 width. */
  mk_grid_span_md?: Maybe<Scalars['Float']>;
  /** Span for small screens (640px). Enter 1-12. E.g., 3 = 1/4 width, 6 = 1/2 width. */
  mk_grid_span_sm?: Maybe<Scalars['Float']>;
  /** Span for extra-large screens (1440px). Enter 1-12. E.g., 3 = 1/4 width, 6 = 1/2 width. */
  mk_grid_span_xl?: Maybe<Scalars['Float']>;
  /** Span for extra small screens (360px or less). Enter 1-12. E.g., 3 = 1/4 width, 6 = 1/2 width. */
  mk_grid_span_xsm?: Maybe<Scalars['Float']>;
  mk_label?: Maybe<Scalars['String']>;
  mk_picture?: Maybe<SrcSetImage>;
  mk_position?: Maybe<Scalars['String']>;
  mk_sub_builder_array?: Maybe<Array<Maybe<MkSubBodyOrMkSubBodyContentLoveOrMkSubBodyHtpOrMkSubCtaOrMkSubCtaHtpOrMkSubCtaRectangleOrMkSubHeaderOrMkSubHeaderLarge>>>;
};

export type MkInfoCardFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  cardLinkAnalyticsEventName?: InputMaybe<StringFilter>;
  cardProductAnalyticsEventProperty?: InputMaybe<StringFilter>;
  exploreItemContentMaxWidth?: InputMaybe<StringFilter>;
  mk_OverlayOpacity?: InputMaybe<FloatFilter>;
  mk_OverlayOpacityColor?: InputMaybe<SimplerColorFilter>;
  mk_cardLink?: InputMaybe<StringFilter>;
  mk_grid_span_lg?: InputMaybe<FloatFilter>;
  mk_grid_span_md?: InputMaybe<FloatFilter>;
  mk_grid_span_sm?: InputMaybe<FloatFilter>;
  mk_grid_span_xl?: InputMaybe<FloatFilter>;
  mk_grid_span_xsm?: InputMaybe<FloatFilter>;
  mk_label?: InputMaybe<StringFilter>;
  mk_picture?: InputMaybe<SrcSetImageFilter>;
  mk_position?: InputMaybe<StringFilter>;
};

export type MkInfoCardSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  cardLinkAnalyticsEventName?: InputMaybe<SortOrder>;
  cardProductAnalyticsEventProperty?: InputMaybe<SortOrder>;
  exploreItemContentMaxWidth?: InputMaybe<SortOrder>;
  mk_OverlayOpacity?: InputMaybe<SortOrder>;
  mk_OverlayOpacityColor?: InputMaybe<SimplerColorSorting>;
  mk_cardLink?: InputMaybe<SortOrder>;
  mk_grid_span_lg?: InputMaybe<SortOrder>;
  mk_grid_span_md?: InputMaybe<SortOrder>;
  mk_grid_span_sm?: InputMaybe<SortOrder>;
  mk_grid_span_xl?: InputMaybe<SortOrder>;
  mk_grid_span_xsm?: InputMaybe<SortOrder>;
  mk_label?: InputMaybe<SortOrder>;
  mk_picture?: InputMaybe<SrcSetImageSorting>;
  mk_position?: InputMaybe<SortOrder>;
};

export type MkInfoCardsTemplate = {
  __typename?: 'MkInfoCardsTemplate';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_BackgroundColor?: Maybe<SimplerColor>;
  mk_cards?: Maybe<Array<Maybe<MkInfoCard>>>;
  /** Only used in Sanity To Label Component */
  mk_name?: Maybe<Scalars['String']>;
  moduleAnalyticsEventProperty?: Maybe<Scalars['String']>;
  placementAnalyticsEventProperty?: Maybe<Scalars['String']>;
};

export type MkInfoCardsTemplateFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_BackgroundColor?: InputMaybe<SimplerColorFilter>;
  mk_name?: InputMaybe<StringFilter>;
  moduleAnalyticsEventProperty?: InputMaybe<StringFilter>;
  placementAnalyticsEventProperty?: InputMaybe<StringFilter>;
};

export type MkInfoCardsTemplateSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_BackgroundColor?: InputMaybe<SimplerColorSorting>;
  mk_name?: InputMaybe<SortOrder>;
  moduleAnalyticsEventProperty?: InputMaybe<SortOrder>;
  placementAnalyticsEventProperty?: InputMaybe<SortOrder>;
};

export type MkMarketingPage = Document & {
  __typename?: 'MkMarketingPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  mk_footer?: Maybe<Scalars['Boolean']>;
  mk_header?: Maybe<Scalars['String']>;
  mk_pageBuilder?: Maybe<Array<Maybe<MkCallToActionOrMkCarouselHeroOrMkCustomHtmlTemplateOrMkCustomJsTemplateOrMkHeadingOrMkHeroOrMkInfoCardsTemplateOrMkResponsiveBannerOrMkSpacerOrMkWhereCanYouPlayTemplateOrMkWhyFanDuelTemplate>>>;
  mk_pageNameAnalyticsEventProperty?: Maybe<Scalars['String']>;
  mk_seo?: Maybe<Seo>;
  mk_slug?: Maybe<Slug>;
};

export type MkMarketingPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  mk_footer?: InputMaybe<BooleanFilter>;
  mk_header?: InputMaybe<StringFilter>;
  mk_pageNameAnalyticsEventProperty?: InputMaybe<StringFilter>;
  mk_seo?: InputMaybe<SeoFilter>;
  mk_slug?: InputMaybe<SlugFilter>;
};

export type MkMarketingPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  mk_footer?: InputMaybe<SortOrder>;
  mk_header?: InputMaybe<SortOrder>;
  mk_pageNameAnalyticsEventProperty?: InputMaybe<SortOrder>;
  mk_seo?: InputMaybe<SeoSorting>;
  mk_slug?: InputMaybe<SlugSorting>;
};

export type MkProductOptions = {
  __typename?: 'MkProductOptions';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  availableLocations?: Maybe<Array<Maybe<LocationsList>>>;
  /** Enter the absolute URL for the "View Details" link under the tab bar. Example: https://www.fanduel.com/an-example */
  detailsUrl?: Maybe<Scalars['String']>;
  /** This text displays a disclaimer about the current product locations list. For example, for Sportsbook: "This list does not include retail locations." */
  disclaimerText?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export type MkProductOptionsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  detailsUrl?: InputMaybe<StringFilter>;
  disclaimerText?: InputMaybe<StringFilter>;
  productName?: InputMaybe<StringFilter>;
};

export type MkProductOptionsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  detailsUrl?: InputMaybe<SortOrder>;
  disclaimerText?: InputMaybe<SortOrder>;
  productName?: InputMaybe<SortOrder>;
};

export type MkRedirect = Document & {
  __typename?: 'MkRedirect';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  mk_base_path?: Maybe<Scalars['Boolean']>;
  mk_enabled?: Maybe<Scalars['Boolean']>;
  mk_new_path?: Maybe<Scalars['String']>;
  mk_old_path?: Maybe<Scalars['String']>;
  mk_permanent?: Maybe<Scalars['Boolean']>;
};

export type MkRedirectFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  mk_base_path?: InputMaybe<BooleanFilter>;
  mk_enabled?: InputMaybe<BooleanFilter>;
  mk_new_path?: InputMaybe<StringFilter>;
  mk_old_path?: InputMaybe<StringFilter>;
  mk_permanent?: InputMaybe<BooleanFilter>;
};

export type MkRedirectSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  mk_base_path?: InputMaybe<SortOrder>;
  mk_enabled?: InputMaybe<SortOrder>;
  mk_new_path?: InputMaybe<SortOrder>;
  mk_old_path?: InputMaybe<SortOrder>;
  mk_permanent?: InputMaybe<SortOrder>;
};

export type MkResponsiveBanner = {
  __typename?: 'MkResponsiveBanner';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Alternative text for the image (used for accessibility) */
  altText?: Maybe<Scalars['String']>;
  /** Link to navigate when the CTA button is clicked */
  ctaLink?: Maybe<Scalars['String']>;
  desktopImage?: Maybe<Image>;
  mobileImage?: Maybe<Image>;
  moduleAnalyticsEventProperty?: Maybe<Scalars['String']>;
  placementAnalyticsEventProperty?: Maybe<Scalars['String']>;
  tabletImage?: Maybe<Image>;
  /** Title for the banner (appears in the list of entries) */
  title?: Maybe<Scalars['String']>;
};

export type MkResponsiveBannerFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  altText?: InputMaybe<StringFilter>;
  ctaLink?: InputMaybe<StringFilter>;
  desktopImage?: InputMaybe<ImageFilter>;
  mobileImage?: InputMaybe<ImageFilter>;
  moduleAnalyticsEventProperty?: InputMaybe<StringFilter>;
  placementAnalyticsEventProperty?: InputMaybe<StringFilter>;
  tabletImage?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MkResponsiveBannerSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  ctaLink?: InputMaybe<SortOrder>;
  desktopImage?: InputMaybe<ImageSorting>;
  mobileImage?: InputMaybe<ImageSorting>;
  moduleAnalyticsEventProperty?: InputMaybe<SortOrder>;
  placementAnalyticsEventProperty?: InputMaybe<SortOrder>;
  tabletImage?: InputMaybe<ImageSorting>;
  title?: InputMaybe<SortOrder>;
};

export type MkRewrite = Document & {
  __typename?: 'MkRewrite';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  mk_enabled?: Maybe<Scalars['Boolean']>;
  mk_new_path?: Maybe<Scalars['String']>;
  mk_old_path?: Maybe<Scalars['String']>;
};

export type MkRewriteFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  mk_enabled?: InputMaybe<BooleanFilter>;
  mk_new_path?: InputMaybe<StringFilter>;
  mk_old_path?: InputMaybe<StringFilter>;
};

export type MkRewriteSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  mk_enabled?: InputMaybe<SortOrder>;
  mk_new_path?: InputMaybe<SortOrder>;
  mk_old_path?: InputMaybe<SortOrder>;
};

export type MkSpacer = {
  __typename?: 'MkSpacer';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<SimplerColor>;
  /** Vertical spacing when no breakpoint matched (screens 0px and above). */
  defaultSpacing?: Maybe<Scalars['Float']>;
  /** Vertical spacing in px on screens 1024px and above. */
  spacingBreakpointLg?: Maybe<Scalars['Float']>;
  /** Vertical spacing in px on screens 960px and above. */
  spacingBreakpointMd?: Maybe<Scalars['Float']>;
  /** Vertical spacing in px on screens 640px and above. */
  spacingBreakpointSm?: Maybe<Scalars['Float']>;
  /** Vertical spacing in px on screens 1440px and above. */
  spacingBreakpointXl?: Maybe<Scalars['Float']>;
  /** Vertical spacing in px on screens 360px and above. */
  spacingBreakpointXsm?: Maybe<Scalars['Float']>;
  /** Vertical spacing in px on screens 1920px and above. */
  spacingBreakpointXxl?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type MkSpacerFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  backgroundColor?: InputMaybe<SimplerColorFilter>;
  defaultSpacing?: InputMaybe<FloatFilter>;
  spacingBreakpointLg?: InputMaybe<FloatFilter>;
  spacingBreakpointMd?: InputMaybe<FloatFilter>;
  spacingBreakpointSm?: InputMaybe<FloatFilter>;
  spacingBreakpointXl?: InputMaybe<FloatFilter>;
  spacingBreakpointXsm?: InputMaybe<FloatFilter>;
  spacingBreakpointXxl?: InputMaybe<FloatFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MkSpacerSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  backgroundColor?: InputMaybe<SimplerColorSorting>;
  defaultSpacing?: InputMaybe<SortOrder>;
  spacingBreakpointLg?: InputMaybe<SortOrder>;
  spacingBreakpointMd?: InputMaybe<SortOrder>;
  spacingBreakpointSm?: InputMaybe<SortOrder>;
  spacingBreakpointXl?: InputMaybe<SortOrder>;
  spacingBreakpointXsm?: InputMaybe<SortOrder>;
  spacingBreakpointXxl?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type MkSubBody = {
  __typename?: 'MkSubBody';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_body?: Maybe<Scalars['String']>;
  mk_bodyColor?: Maybe<SimplerColor>;
};

export type MkSubBodyContentLove = {
  __typename?: 'MkSubBodyContentLove';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_body?: Maybe<Scalars['String']>;
  mk_bodyColor?: Maybe<SimplerColor>;
};

export type MkSubBodyContentLoveFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_body?: InputMaybe<StringFilter>;
  mk_bodyColor?: InputMaybe<SimplerColorFilter>;
};

export type MkSubBodyContentLoveSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_body?: InputMaybe<SortOrder>;
  mk_bodyColor?: InputMaybe<SimplerColorSorting>;
};

export type MkSubBodyFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_body?: InputMaybe<StringFilter>;
  mk_bodyColor?: InputMaybe<SimplerColorFilter>;
};

export type MkSubBodyHtp = {
  __typename?: 'MkSubBodyHtp';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_body?: Maybe<Scalars['String']>;
  mk_bodyColor?: Maybe<SimplerColor>;
};

export type MkSubBodyHtpFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_body?: InputMaybe<StringFilter>;
  mk_bodyColor?: InputMaybe<SimplerColorFilter>;
};

export type MkSubBodyHtpSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_body?: InputMaybe<SortOrder>;
  mk_bodyColor?: InputMaybe<SimplerColorSorting>;
};

export type MkSubBodyOrMkSubBodyContentLoveOrMkSubBodyHtpOrMkSubCtaOrMkSubCtaHtpOrMkSubCtaRectangleOrMkSubHeaderOrMkSubHeaderLarge = MkSubBody | MkSubBodyContentLove | MkSubBodyHtp | MkSubCta | MkSubCtaHtp | MkSubCtaRectangle | MkSubHeader | MkSubHeaderLarge;

export type MkSubBodySorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_body?: InputMaybe<SortOrder>;
  mk_bodyColor?: InputMaybe<SimplerColorSorting>;
};

export type MkSubCta = {
  __typename?: 'MkSubCta';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_CTA_Color?: Maybe<SimplerColor>;
  mk_callToAction?: Maybe<Scalars['String']>;
  mk_callToActionImage?: Maybe<Image>;
  mk_callToActionLink?: Maybe<Scalars['String']>;
};

export type MkSubCtaFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_CTA_Color?: InputMaybe<SimplerColorFilter>;
  mk_callToAction?: InputMaybe<StringFilter>;
  mk_callToActionImage?: InputMaybe<ImageFilter>;
  mk_callToActionLink?: InputMaybe<StringFilter>;
};

export type MkSubCtaHtp = {
  __typename?: 'MkSubCtaHtp';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_callToActionImage?: Maybe<Image>;
  mk_callToActionLink?: Maybe<Scalars['String']>;
  mk_callToAction_text?: Maybe<Scalars['String']>;
};

export type MkSubCtaHtpFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_callToActionImage?: InputMaybe<ImageFilter>;
  mk_callToActionLink?: InputMaybe<StringFilter>;
  mk_callToAction_text?: InputMaybe<StringFilter>;
};

export type MkSubCtaHtpSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_callToActionImage?: InputMaybe<ImageSorting>;
  mk_callToActionLink?: InputMaybe<SortOrder>;
  mk_callToAction_text?: InputMaybe<SortOrder>;
};

export type MkSubCtaRectangle = {
  __typename?: 'MkSubCtaRectangle';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  callToActionLinkAnalyticsEventName?: Maybe<Scalars['String']>;
  mk_callToActionLink?: Maybe<Scalars['String']>;
  mk_callToAction_text?: Maybe<Scalars['String']>;
};

export type MkSubCtaRectangleFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  callToActionLinkAnalyticsEventName?: InputMaybe<StringFilter>;
  mk_callToActionLink?: InputMaybe<StringFilter>;
  mk_callToAction_text?: InputMaybe<StringFilter>;
};

export type MkSubCtaRectangleSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  callToActionLinkAnalyticsEventName?: InputMaybe<SortOrder>;
  mk_callToActionLink?: InputMaybe<SortOrder>;
  mk_callToAction_text?: InputMaybe<SortOrder>;
};

export type MkSubCtaSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_CTA_Color?: InputMaybe<SimplerColorSorting>;
  mk_callToAction?: InputMaybe<SortOrder>;
  mk_callToActionImage?: InputMaybe<ImageSorting>;
  mk_callToActionLink?: InputMaybe<SortOrder>;
};

export type MkSubHeader = {
  __typename?: 'MkSubHeader';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_HeaderImage?: Maybe<Image>;
  mk_logoHeaderImage?: Maybe<Image>;
};

export type MkSubHeaderFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_HeaderImage?: InputMaybe<ImageFilter>;
  mk_logoHeaderImage?: InputMaybe<ImageFilter>;
};

export type MkSubHeaderLarge = {
  __typename?: 'MkSubHeaderLarge';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  mk_sub_header_large?: Maybe<Image>;
};

export type MkSubHeaderLargeFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  mk_sub_header_large?: InputMaybe<ImageFilter>;
};

export type MkSubHeaderLargeSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_sub_header_large?: InputMaybe<ImageSorting>;
};

export type MkSubHeaderSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  mk_HeaderImage?: InputMaybe<ImageSorting>;
  mk_logoHeaderImage?: InputMaybe<ImageSorting>;
};

export type MkWhereCanYouPlayTemplate = {
  __typename?: 'MkWhereCanYouPlayTemplate';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<MkProductOptions>>>;
};

export type MkWhereCanYouPlayTemplateFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
};

export type MkWhereCanYouPlayTemplateSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};

export type MkWhyFanDuelCard = {
  __typename?: 'MkWhyFanDuelCard';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** This is the content that will be presented in the card. Please ensure valid semantic HTML is input here as well as any analytics tracking events that may be required. */
  html?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MkWhyFanDuelCardFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  html?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MkWhyFanDuelCardSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  html?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type MkWhyFanDuelTemplate = {
  __typename?: 'MkWhyFanDuelTemplate';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  whyFanduel?: Maybe<Array<Maybe<MkWhyFanDuelCard>>>;
};

export type MkWhyFanDuelTemplateFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  subtext?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MkWhyFanDuelTemplateSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  subtext?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type OpenGraph = {
  __typename?: 'OpenGraph';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  title?: Maybe<Scalars['String']>;
  /** 'website', or 'article' etc */
  type?: Maybe<Scalars['String']>;
};

export type OpenGraphFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type OpenGraphSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type OptimusFanduelProPage = Document & {
  __typename?: 'OptimusFanduelProPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  activeBenefits?: Maybe<Array<Maybe<OptimusSubBenefit>>>;
  banner?: Maybe<OptimusSubBanner>;
  faqs?: Maybe<Array<Maybe<OptimusSubAccordionItem>>>;
  /** This should match the CPP Promo Code the user is bucketed to */
  groupPromotionId?: Maybe<Scalars['String']>;
  howTos?: Maybe<Array<Maybe<OptimusSubAccordionItem>>>;
};

export type OptimusFanduelProPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  banner?: InputMaybe<OptimusSubBannerFilter>;
  groupPromotionId?: InputMaybe<StringFilter>;
};

export type OptimusFanduelProPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  banner?: InputMaybe<OptimusSubBannerSorting>;
  groupPromotionId?: InputMaybe<SortOrder>;
};

export type OptimusSubAccordionItem = {
  __typename?: 'OptimusSubAccordionItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type OptimusSubAccordionItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type OptimusSubAccordionItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type OptimusSubBanner = {
  __typename?: 'OptimusSubBanner';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  optInButtonText?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type OptimusSubBannerFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
  optInButtonText?: InputMaybe<StringFilter>;
  tag?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type OptimusSubBannerSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  optInButtonText?: InputMaybe<SortOrder>;
  tag?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type OptimusSubBenefit = {
  __typename?: 'OptimusSubBenefit';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  postOptInButtonText?: Maybe<Scalars['String']>;
  /** Text shown when the promo is not yet available for the user to opt into */
  preOptInAvailableText?: Maybe<Scalars['String']>;
  preOptInButtonText?: Maybe<Scalars['String']>;
  promoCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type OptimusSubBenefitFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  action?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
  buttonText?: InputMaybe<StringFilter>;
  icon?: InputMaybe<StringFilter>;
  postOptInButtonText?: InputMaybe<StringFilter>;
  preOptInAvailableText?: InputMaybe<StringFilter>;
  preOptInButtonText?: InputMaybe<StringFilter>;
  promoCode?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type OptimusSubBenefitSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  action?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  buttonText?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  postOptInButtonText?: InputMaybe<SortOrder>;
  preOptInAvailableText?: InputMaybe<SortOrder>;
  preOptInButtonText?: InputMaybe<SortOrder>;
  promoCode?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type PpBettingMarket = Document & {
  __typename?: 'PpBettingMarket';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  definition?: Maybe<Scalars['String']>;
  example?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  title?: Maybe<Scalars['String']>;
  /** Single, Parlay, SGP, or SPG+ label for toggling the Popular Betting Markets section */
  type?: Maybe<Scalars['String']>;
};

export type PpBettingMarketFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  definition?: InputMaybe<StringFilter>;
  example?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type PpBettingMarketSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  definition?: InputMaybe<SortOrder>;
  example?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type PpContentBlock = Document & {
  __typename?: 'PpContentBlock';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  descriptionRaw?: Maybe<Scalars['JSON']>;
  images?: Maybe<Array<Maybe<Image>>>;
  links?: Maybe<Array<Maybe<PpLink>>>;
  title?: Maybe<Scalars['String']>;
};

export type PpContentBlockFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PpContentBlockOrPpHeroOrPpSectionBettingMarketOrPpSectionFaqOrPpSectionOverview = PpContentBlock | PpHero | PpSectionBettingMarket | PpSectionFaq | PpSectionOverview;

export type PpContentBlockSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PpFaq = Document & {
  __typename?: 'PpFaq';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  answerRaw?: Maybe<Scalars['JSON']>;
  question?: Maybe<Scalars['String']>;
};

export type PpFaqFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  question?: InputMaybe<StringFilter>;
};

export type PpFaqSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  question?: InputMaybe<SortOrder>;
};

export type PpHero = {
  __typename?: 'PpHero';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  subtitleRaw?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

export type PpHeroFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PpHeroSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  title?: InputMaybe<SortOrder>;
};

export type PpLink = {
  __typename?: 'PpLink';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
  icon?: Maybe<Image>;
  label?: Maybe<Scalars['String']>;
};

export type PpLinkFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  icon?: InputMaybe<ImageFilter>;
  label?: InputMaybe<StringFilter>;
};

export type PpLinkSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  icon?: InputMaybe<ImageSorting>;
  label?: InputMaybe<SortOrder>;
};

export type PpPage = Document & {
  __typename?: 'PpPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  pageBuilder?: Maybe<Array<Maybe<PpContentBlockOrPpHeroOrPpSectionBettingMarketOrPpSectionFaqOrPpSectionOverview>>>;
  title?: Maybe<Scalars['String']>;
};

export type PpPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PpPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PpSectionBettingMarket = {
  __typename?: 'PpSectionBettingMarket';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bettingMarkets?: Maybe<Array<Maybe<PpBettingMarket>>>;
  title?: Maybe<Scalars['String']>;
};

export type PpSectionBettingMarketFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PpSectionBettingMarketSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PpSectionFaq = {
  __typename?: 'PpSectionFaq';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  faqs?: Maybe<Array<Maybe<PpFaq>>>;
  title?: Maybe<Scalars['String']>;
};

export type PpSectionFaqFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PpSectionFaqSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PpSectionOverview = {
  __typename?: 'PpSectionOverview';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  cards?: Maybe<Array<Maybe<PpContentBlock>>>;
  subtitleRaw?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

export type PpSectionOverviewFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PpSectionOverviewSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PrContact = {
  __typename?: 'PrContact';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PrContactFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PrContactSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PrLeader = Document & {
  __typename?: 'PrLeader';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  biographyRaw?: Maybe<Scalars['JSON']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
};

export type PrLeaderFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  image?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
};

export type PrLeaderSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
};

export type PrLogo = Document & {
  __typename?: 'PrLogo';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  fileName?: Maybe<Scalars['String']>;
  logo?: Maybe<Image>;
  logoType?: Maybe<Scalars['String']>;
};

export type PrLogoFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  fileName?: InputMaybe<StringFilter>;
  logo?: InputMaybe<ImageFilter>;
  logoType?: InputMaybe<StringFilter>;
};

export type PrLogoItem = {
  __typename?: 'PrLogoItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  logo?: Maybe<Image>;
  submenu?: Maybe<Array<Maybe<PrLogoItem>>>;
};

export type PrLogoItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  logo?: InputMaybe<ImageFilter>;
};

export type PrLogoItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  fileName?: InputMaybe<SortOrder>;
  logo?: InputMaybe<ImageSorting>;
};

export type PrLogoSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  fileName?: InputMaybe<SortOrder>;
  logo?: InputMaybe<ImageSorting>;
  logoType?: InputMaybe<SortOrder>;
};

export type PrMenu = Document & {
  __typename?: 'PrMenu';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  menuItems?: Maybe<Array<Maybe<PrMenuItem>>>;
  name?: Maybe<Scalars['String']>;
};

export type PrMenuFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PrMenuItem = {
  __typename?: 'PrMenuItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  newWindow?: Maybe<Scalars['Boolean']>;
  submenu?: Maybe<Array<Maybe<PrMenuItem>>>;
};

export type PrMenuItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  newWindow?: InputMaybe<BooleanFilter>;
};

export type PrMenuItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  newWindow?: InputMaybe<SortOrder>;
};

export type PrMenuSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PrPage = Document & {
  __typename?: 'PrPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  banner?: Maybe<Image>;
  bodyRaw?: Maybe<Scalars['JSON']>;
  contacts?: Maybe<Array<Maybe<PrContact>>>;
  fdtvTalent?: Maybe<Array<Maybe<PrTalent>>>;
  leadership?: Maybe<Array<Maybe<PrLeader>>>;
  logos?: Maybe<Array<Maybe<PrLogoItem>>>;
  pageSections?: Maybe<Array<Maybe<PrPageSection>>>;
  pageType?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<PrProduct>>>;
  reel?: Maybe<File>;
};

export type PrPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  banner?: InputMaybe<ImageFilter>;
  pageType?: InputMaybe<StringFilter>;
  reel?: InputMaybe<FileFilter>;
};

export type PrPageSection = Document & {
  __typename?: 'PrPageSection';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  partnerCarousel?: Maybe<Array<Maybe<PrPartner>>>;
  sectionTitle?: Maybe<Scalars['String']>;
  sectionType?: Maybe<Scalars['String']>;
};

export type PrPageSectionFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  sectionTitle?: InputMaybe<StringFilter>;
  sectionType?: InputMaybe<StringFilter>;
};

export type PrPageSectionSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  sectionTitle?: InputMaybe<SortOrder>;
  sectionType?: InputMaybe<SortOrder>;
};

export type PrPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  banner?: InputMaybe<ImageSorting>;
  pageType?: InputMaybe<SortOrder>;
  reel?: InputMaybe<FileSorting>;
};

export type PrPartner = Document & {
  __typename?: 'PrPartner';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
};

export type PrPartnerFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  image?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PrPartnerSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
};

export type PrProduct = Document & {
  __typename?: 'PrProduct';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PrProductFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  image?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type PrProductSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type PrRelease = Document & {
  __typename?: 'PrRelease';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  bodyRaw?: Maybe<Scalars['JSON']>;
  datePublished?: Maybe<Scalars['Date']>;
  image?: Maybe<Image>;
  /** Optional: Insert a stylized pull-quote in the press release layout */
  pullQuote?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  /** Optional: Insert a subheading below the main press release headline */
  subheading?: Maybe<Scalars['String']>;
  /** Maximum 300 characters */
  title?: Maybe<Scalars['String']>;
};

export type PrReleaseFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  datePublished?: InputMaybe<DateFilter>;
  image?: InputMaybe<ImageFilter>;
  pullQuote?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  subheading?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PrReleaseSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  datePublished?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  pullQuote?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
  subheading?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PrTalent = Document & {
  __typename?: 'PrTalent';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  biographyRaw?: Maybe<Scalars['JSON']>;
  igLink?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Slug>;
  ttLink?: Maybe<Scalars['String']>;
  xLink?: Maybe<Scalars['String']>;
};

export type PrTalentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  igLink?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  ttLink?: InputMaybe<StringFilter>;
  xLink?: InputMaybe<StringFilter>;
};

export type PrTalentSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  igLink?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
  ttLink?: InputMaybe<SortOrder>;
  xLink?: InputMaybe<SortOrder>;
};

export type Query = {
  __typename?: 'Query';
  Document?: Maybe<Document>;
  LocationsList?: Maybe<LocationsList>;
  MediaTag?: Maybe<MediaTag>;
  Menu?: Maybe<Menu>;
  MkHomePage?: Maybe<MkHomePage>;
  MkMarketingPage?: Maybe<MkMarketingPage>;
  MkRedirect?: Maybe<MkRedirect>;
  MkRewrite?: Maybe<MkRewrite>;
  OptimusFanduelProPage?: Maybe<OptimusFanduelProPage>;
  PpBettingMarket?: Maybe<PpBettingMarket>;
  PpContentBlock?: Maybe<PpContentBlock>;
  PpFaq?: Maybe<PpFaq>;
  PpPage?: Maybe<PpPage>;
  PrLeader?: Maybe<PrLeader>;
  PrLogo?: Maybe<PrLogo>;
  PrMenu?: Maybe<PrMenu>;
  PrPage?: Maybe<PrPage>;
  PrPageSection?: Maybe<PrPageSection>;
  PrPartner?: Maybe<PrPartner>;
  PrProduct?: Maybe<PrProduct>;
  PrRelease?: Maybe<PrRelease>;
  PrTalent?: Maybe<PrTalent>;
  SanityFileAsset?: Maybe<SanityFileAsset>;
  SanityImageAsset?: Maybe<SanityImageAsset>;
  Settings?: Maybe<Settings>;
  UkButton?: Maybe<UkButton>;
  UkCareer?: Maybe<UkCareer>;
  UkCareerProgressionLevel?: Maybe<UkCareerProgressionLevel>;
  UkEmployeeBenefit?: Maybe<UkEmployeeBenefit>;
  UkEmployeeProfile?: Maybe<UkEmployeeProfile>;
  UkEmployeeTestimonial?: Maybe<UkEmployeeTestimonial>;
  UkFdprinciple?: Maybe<UkFdprinciple>;
  UkInterviewStep?: Maybe<UkInterviewStep>;
  UkLocationIcon?: Maybe<UkLocationIcon>;
  UkMenu?: Maybe<UkMenu>;
  UkPage?: Maybe<UkPage>;
  UkPageSection?: Maybe<UkPageSection>;
  UkProduct?: Maybe<UkProduct>;
  allDocument: Array<Document>;
  allLocationsList: Array<LocationsList>;
  allMediaTag: Array<MediaTag>;
  allMenu: Array<Menu>;
  allMkHomePage: Array<MkHomePage>;
  allMkMarketingPage: Array<MkMarketingPage>;
  allMkRedirect: Array<MkRedirect>;
  allMkRewrite: Array<MkRewrite>;
  allOptimusFanduelProPage: Array<OptimusFanduelProPage>;
  allPpBettingMarket: Array<PpBettingMarket>;
  allPpContentBlock: Array<PpContentBlock>;
  allPpFaq: Array<PpFaq>;
  allPpPage: Array<PpPage>;
  allPrLeader: Array<PrLeader>;
  allPrLogo: Array<PrLogo>;
  allPrMenu: Array<PrMenu>;
  allPrPage: Array<PrPage>;
  allPrPageSection: Array<PrPageSection>;
  allPrPartner: Array<PrPartner>;
  allPrProduct: Array<PrProduct>;
  allPrRelease: Array<PrRelease>;
  allPrTalent: Array<PrTalent>;
  allSanityFileAsset: Array<SanityFileAsset>;
  allSanityImageAsset: Array<SanityImageAsset>;
  allSettings: Array<Settings>;
  allUkButton: Array<UkButton>;
  allUkCareer: Array<UkCareer>;
  allUkCareerProgressionLevel: Array<UkCareerProgressionLevel>;
  allUkEmployeeBenefit: Array<UkEmployeeBenefit>;
  allUkEmployeeProfile: Array<UkEmployeeProfile>;
  allUkEmployeeTestimonial: Array<UkEmployeeTestimonial>;
  allUkFdprinciple: Array<UkFdprinciple>;
  allUkInterviewStep: Array<UkInterviewStep>;
  allUkLocationIcon: Array<UkLocationIcon>;
  allUkMenu: Array<UkMenu>;
  allUkPage: Array<UkPage>;
  allUkPageSection: Array<UkPageSection>;
  allUkProduct: Array<UkProduct>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsListArgs = {
  id: Scalars['ID'];
};


export type QueryMediaTagArgs = {
  id: Scalars['ID'];
};


export type QueryMenuArgs = {
  id: Scalars['ID'];
};


export type QueryMkHomePageArgs = {
  id: Scalars['ID'];
};


export type QueryMkMarketingPageArgs = {
  id: Scalars['ID'];
};


export type QueryMkRedirectArgs = {
  id: Scalars['ID'];
};


export type QueryMkRewriteArgs = {
  id: Scalars['ID'];
};


export type QueryOptimusFanduelProPageArgs = {
  id: Scalars['ID'];
};


export type QueryPpBettingMarketArgs = {
  id: Scalars['ID'];
};


export type QueryPpContentBlockArgs = {
  id: Scalars['ID'];
};


export type QueryPpFaqArgs = {
  id: Scalars['ID'];
};


export type QueryPpPageArgs = {
  id: Scalars['ID'];
};


export type QueryPrLeaderArgs = {
  id: Scalars['ID'];
};


export type QueryPrLogoArgs = {
  id: Scalars['ID'];
};


export type QueryPrMenuArgs = {
  id: Scalars['ID'];
};


export type QueryPrPageArgs = {
  id: Scalars['ID'];
};


export type QueryPrPageSectionArgs = {
  id: Scalars['ID'];
};


export type QueryPrPartnerArgs = {
  id: Scalars['ID'];
};


export type QueryPrProductArgs = {
  id: Scalars['ID'];
};


export type QueryPrReleaseArgs = {
  id: Scalars['ID'];
};


export type QueryPrTalentArgs = {
  id: Scalars['ID'];
};


export type QuerySanityFileAssetArgs = {
  id: Scalars['ID'];
};


export type QuerySanityImageAssetArgs = {
  id: Scalars['ID'];
};


export type QuerySettingsArgs = {
  id: Scalars['ID'];
};


export type QueryUkButtonArgs = {
  id: Scalars['ID'];
};


export type QueryUkCareerArgs = {
  id: Scalars['ID'];
};


export type QueryUkCareerProgressionLevelArgs = {
  id: Scalars['ID'];
};


export type QueryUkEmployeeBenefitArgs = {
  id: Scalars['ID'];
};


export type QueryUkEmployeeProfileArgs = {
  id: Scalars['ID'];
};


export type QueryUkEmployeeTestimonialArgs = {
  id: Scalars['ID'];
};


export type QueryUkFdprincipleArgs = {
  id: Scalars['ID'];
};


export type QueryUkInterviewStepArgs = {
  id: Scalars['ID'];
};


export type QueryUkLocationIconArgs = {
  id: Scalars['ID'];
};


export type QueryUkMenuArgs = {
  id: Scalars['ID'];
};


export type QueryUkPageArgs = {
  id: Scalars['ID'];
};


export type QueryUkPageSectionArgs = {
  id: Scalars['ID'];
};


export type QueryUkProductArgs = {
  id: Scalars['ID'];
};


export type QueryAllDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<DocumentSorting>>;
  where?: InputMaybe<DocumentFilter>;
};


export type QueryAllLocationsListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<LocationsListSorting>>;
  where?: InputMaybe<LocationsListFilter>;
};


export type QueryAllMediaTagArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MediaTagSorting>>;
  where?: InputMaybe<MediaTagFilter>;
};


export type QueryAllMenuArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MenuSorting>>;
  where?: InputMaybe<MenuFilter>;
};


export type QueryAllMkHomePageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MkHomePageSorting>>;
  where?: InputMaybe<MkHomePageFilter>;
};


export type QueryAllMkMarketingPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MkMarketingPageSorting>>;
  where?: InputMaybe<MkMarketingPageFilter>;
};


export type QueryAllMkRedirectArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MkRedirectSorting>>;
  where?: InputMaybe<MkRedirectFilter>;
};


export type QueryAllMkRewriteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MkRewriteSorting>>;
  where?: InputMaybe<MkRewriteFilter>;
};


export type QueryAllOptimusFanduelProPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<OptimusFanduelProPageSorting>>;
  where?: InputMaybe<OptimusFanduelProPageFilter>;
};


export type QueryAllPpBettingMarketArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PpBettingMarketSorting>>;
  where?: InputMaybe<PpBettingMarketFilter>;
};


export type QueryAllPpContentBlockArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PpContentBlockSorting>>;
  where?: InputMaybe<PpContentBlockFilter>;
};


export type QueryAllPpFaqArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PpFaqSorting>>;
  where?: InputMaybe<PpFaqFilter>;
};


export type QueryAllPpPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PpPageSorting>>;
  where?: InputMaybe<PpPageFilter>;
};


export type QueryAllPrLeaderArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrLeaderSorting>>;
  where?: InputMaybe<PrLeaderFilter>;
};


export type QueryAllPrLogoArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrLogoSorting>>;
  where?: InputMaybe<PrLogoFilter>;
};


export type QueryAllPrMenuArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrMenuSorting>>;
  where?: InputMaybe<PrMenuFilter>;
};


export type QueryAllPrPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrPageSorting>>;
  where?: InputMaybe<PrPageFilter>;
};


export type QueryAllPrPageSectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrPageSectionSorting>>;
  where?: InputMaybe<PrPageSectionFilter>;
};


export type QueryAllPrPartnerArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrPartnerSorting>>;
  where?: InputMaybe<PrPartnerFilter>;
};


export type QueryAllPrProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrProductSorting>>;
  where?: InputMaybe<PrProductFilter>;
};


export type QueryAllPrReleaseArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrReleaseSorting>>;
  where?: InputMaybe<PrReleaseFilter>;
};


export type QueryAllPrTalentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PrTalentSorting>>;
  where?: InputMaybe<PrTalentFilter>;
};


export type QueryAllSanityFileAssetArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SanityFileAssetSorting>>;
  where?: InputMaybe<SanityFileAssetFilter>;
};


export type QueryAllSanityImageAssetArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SanityImageAssetSorting>>;
  where?: InputMaybe<SanityImageAssetFilter>;
};


export type QueryAllSettingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SettingsSorting>>;
  where?: InputMaybe<SettingsFilter>;
};


export type QueryAllUkButtonArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkButtonSorting>>;
  where?: InputMaybe<UkButtonFilter>;
};


export type QueryAllUkCareerArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkCareerSorting>>;
  where?: InputMaybe<UkCareerFilter>;
};


export type QueryAllUkCareerProgressionLevelArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkCareerProgressionLevelSorting>>;
  where?: InputMaybe<UkCareerProgressionLevelFilter>;
};


export type QueryAllUkEmployeeBenefitArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkEmployeeBenefitSorting>>;
  where?: InputMaybe<UkEmployeeBenefitFilter>;
};


export type QueryAllUkEmployeeProfileArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkEmployeeProfileSorting>>;
  where?: InputMaybe<UkEmployeeProfileFilter>;
};


export type QueryAllUkEmployeeTestimonialArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkEmployeeTestimonialSorting>>;
  where?: InputMaybe<UkEmployeeTestimonialFilter>;
};


export type QueryAllUkFdprincipleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkFdprincipleSorting>>;
  where?: InputMaybe<UkFdprincipleFilter>;
};


export type QueryAllUkInterviewStepArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkInterviewStepSorting>>;
  where?: InputMaybe<UkInterviewStepFilter>;
};


export type QueryAllUkLocationIconArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkLocationIconSorting>>;
  where?: InputMaybe<UkLocationIconFilter>;
};


export type QueryAllUkMenuArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkMenuSorting>>;
  where?: InputMaybe<UkMenuFilter>;
};


export type QueryAllUkPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkPageSorting>>;
  where?: InputMaybe<UkPageFilter>;
};


export type QueryAllUkPageSectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkPageSectionSorting>>;
  where?: InputMaybe<UkPageSectionFilter>;
};


export type QueryAllUkProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UkProductSorting>>;
  where?: InputMaybe<UkProductFilter>;
};

export type SanityAssetSourceData = {
  __typename?: 'SanityAssetSourceData';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']>;
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']>;
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']>;
};

export type SanityAssetSourceDataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityAssetSourceDataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityFileAsset = Document & {
  __typename?: 'SanityFileAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  uploadId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  uploadId?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityFileAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  uploadId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityImageAsset = Document & {
  __typename?: 'SanityImageAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<SanityImageMetadata>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  uploadId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<SanityImageMetadataFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  uploadId?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityImageAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SanityImageMetadataSorting>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  uploadId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityImageCrop = {
  __typename?: 'SanityImageCrop';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
};

export type SanityImageCropFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  bottom?: InputMaybe<FloatFilter>;
  left?: InputMaybe<FloatFilter>;
  right?: InputMaybe<FloatFilter>;
  top?: InputMaybe<FloatFilter>;
};

export type SanityImageCropSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  bottom?: InputMaybe<SortOrder>;
  left?: InputMaybe<SortOrder>;
  right?: InputMaybe<SortOrder>;
  top?: InputMaybe<SortOrder>;
};

export type SanityImageDimensions = {
  __typename?: 'SanityImageDimensions';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type SanityImageDimensionsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<FloatFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type SanityImageDimensionsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  aspectRatio?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type SanityImageHotspotFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
  x?: InputMaybe<FloatFilter>;
  y?: InputMaybe<FloatFilter>;
};

export type SanityImageHotspotSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
  x?: InputMaybe<SortOrder>;
  y?: InputMaybe<SortOrder>;
};

export type SanityImageMetadata = {
  __typename?: 'SanityImageMetadata';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  blurHash?: Maybe<Scalars['String']>;
  dimensions?: Maybe<SanityImageDimensions>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  isOpaque?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Geopoint>;
  lqip?: Maybe<Scalars['String']>;
  palette?: Maybe<SanityImagePalette>;
};

export type SanityImageMetadataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  blurHash?: InputMaybe<StringFilter>;
  dimensions?: InputMaybe<SanityImageDimensionsFilter>;
  hasAlpha?: InputMaybe<BooleanFilter>;
  isOpaque?: InputMaybe<BooleanFilter>;
  location?: InputMaybe<GeopointFilter>;
  lqip?: InputMaybe<StringFilter>;
  palette?: InputMaybe<SanityImagePaletteFilter>;
};

export type SanityImageMetadataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  blurHash?: InputMaybe<SortOrder>;
  dimensions?: InputMaybe<SanityImageDimensionsSorting>;
  hasAlpha?: InputMaybe<SortOrder>;
  isOpaque?: InputMaybe<SortOrder>;
  location?: InputMaybe<GeopointSorting>;
  lqip?: InputMaybe<SortOrder>;
  palette?: InputMaybe<SanityImagePaletteSorting>;
};

export type SanityImagePalette = {
  __typename?: 'SanityImagePalette';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
};

export type SanityImagePaletteFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  dominant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  muted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
};

export type SanityImagePaletteSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  dominant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  muted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
};

export type SanityImagePaletteSwatch = {
  __typename?: 'SanityImagePaletteSwatch';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  foreground?: Maybe<Scalars['String']>;
  population?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type SanityImagePaletteSwatchFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  background?: InputMaybe<StringFilter>;
  foreground?: InputMaybe<StringFilter>;
  population?: InputMaybe<FloatFilter>;
  title?: InputMaybe<StringFilter>;
};

export type SanityImagePaletteSwatchSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  background?: InputMaybe<SortOrder>;
  foreground?: InputMaybe<SortOrder>;
  population?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type Sanity_DocumentFilter = {
  /** All documents that are drafts. */
  is_draft?: InputMaybe<Scalars['Boolean']>;
  /** All documents referencing the given document ID. */
  references?: InputMaybe<Scalars['ID']>;
};

export type Seo = {
  __typename?: 'Seo';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  /** Defaults to [basepath]/[slug] */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** Hide this page from search engines and the sitemap */
  noIndex?: Maybe<Scalars['Boolean']>;
  openGraph?: Maybe<OpenGraph>;
  /** Defaults to beginning of the article body */
  seoDescription?: Maybe<Scalars['String']>;
  seoImage?: Maybe<Image>;
  /** comma separated */
  seoKeywords?: Maybe<Scalars['String']>;
  /** comma separated */
  seoSyn?: Maybe<Scalars['String']>;
  /** Defaults to artilce title */
  seoTitle?: Maybe<Scalars['String']>;
};

export type SeoFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  canonicalUrl?: InputMaybe<StringFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  openGraph?: InputMaybe<OpenGraphFilter>;
  seoDescription?: InputMaybe<StringFilter>;
  seoImage?: InputMaybe<ImageFilter>;
  seoKeywords?: InputMaybe<StringFilter>;
  seoSyn?: InputMaybe<StringFilter>;
  seoTitle?: InputMaybe<StringFilter>;
};

export type SeoSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  canonicalUrl?: InputMaybe<SortOrder>;
  noIndex?: InputMaybe<SortOrder>;
  openGraph?: InputMaybe<OpenGraphSorting>;
  seoDescription?: InputMaybe<SortOrder>;
  seoImage?: InputMaybe<ImageSorting>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoSyn?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
};

export type Settings = Document & {
  __typename?: 'Settings';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  clientUrlMarketing?: Maybe<Scalars['String']>;
  clientUrlPress?: Maybe<Scalars['String']>;
  clientUrlUk?: Maybe<Scalars['String']>;
};

export type SettingsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  clientUrlMarketing?: InputMaybe<StringFilter>;
  clientUrlPress?: InputMaybe<StringFilter>;
  clientUrlUk?: InputMaybe<StringFilter>;
};

export type SettingsSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  clientUrlMarketing?: InputMaybe<SortOrder>;
  clientUrlPress?: InputMaybe<SortOrder>;
  clientUrlUk?: InputMaybe<SortOrder>;
};

export type SimplerColor = {
  __typename?: 'SimplerColor';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SimplerColorFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type SimplerColorSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type Slug = {
  __typename?: 'Slug';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type SlugFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  current?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
};

export type SlugSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  current?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  /** Sorts on the value in ascending order. */
  Asc = 'ASC',
  /** Sorts on the value in descending order. */
  Desc = 'DESC'
}

export type Span = {
  __typename?: 'Span';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type SrcSetImage = {
  __typename?: 'SrcSetImage';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  altText?: Maybe<Scalars['String']>;
  lgSrcSet?: Maybe<Image>;
  smSrcSet?: Maybe<Image>;
};

export type SrcSetImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  altText?: InputMaybe<StringFilter>;
  lgSrcSet?: InputMaybe<ImageFilter>;
  smSrcSet?: InputMaybe<ImageFilter>;
};

export type SrcSetImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  lgSrcSet?: InputMaybe<ImageSorting>;
  smSrcSet?: InputMaybe<ImageSorting>;
};

export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Checks if the value is defined. */
  is_defined?: InputMaybe<Scalars['Boolean']>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['String']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<Scalars['String']>>;
};

export type TextColor = {
  __typename?: 'TextColor';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TextColorFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type TextColorSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type UkButton = Document & {
  __typename?: 'UkButton';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  buttonTitle?: Maybe<Scalars['String']>;
  buttonURL?: Maybe<Scalars['String']>;
};

export type UkButtonFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  buttonTitle?: InputMaybe<StringFilter>;
  buttonURL?: InputMaybe<StringFilter>;
};

export type UkButtonSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  buttonTitle?: InputMaybe<SortOrder>;
  buttonURL?: InputMaybe<SortOrder>;
};

export type UkCareer = Document & {
  __typename?: 'UkCareer';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  buttonLinks?: Maybe<Array<Maybe<UkButton>>>;
  career?: Maybe<Scalars['String']>;
  /** Maximum 250 characters */
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  uk_careerProgression?: Maybe<Array<Maybe<UkCareerProgressionLevel>>>;
};

export type UkCareerFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  career?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
};

export type UkCareerProgressionLevel = Document & {
  __typename?: 'UkCareerProgressionLevel';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  career?: Maybe<Scalars['String']>;
  progressionLevel?: Maybe<Scalars['Float']>;
  roleWithinLevel?: Maybe<Array<Maybe<UkRole>>>;
};

export type UkCareerProgressionLevelFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  career?: InputMaybe<StringFilter>;
  progressionLevel?: InputMaybe<FloatFilter>;
};

export type UkCareerProgressionLevelSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  career?: InputMaybe<SortOrder>;
  progressionLevel?: InputMaybe<SortOrder>;
};

export type UkCareerSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  career?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
};

export type UkEmployeeBenefit = Document & {
  __typename?: 'UkEmployeeBenefit';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  benefitName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
};

export type UkEmployeeBenefitFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  benefitName?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  emoji?: InputMaybe<StringFilter>;
};

export type UkEmployeeBenefitSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  benefitName?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  emoji?: InputMaybe<SortOrder>;
};

export type UkEmployeeProfile = Document & {
  __typename?: 'UkEmployeeProfile';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  employeeName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Image>;
};

export type UkEmployeeProfileFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  employeeName?: InputMaybe<StringFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  profilePicture?: InputMaybe<ImageFilter>;
};

export type UkEmployeeProfileSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  employeeName?: InputMaybe<SortOrder>;
  jobTitle?: InputMaybe<SortOrder>;
  profilePicture?: InputMaybe<ImageSorting>;
};

export type UkEmployeeTestimonial = Document & {
  __typename?: 'UkEmployeeTestimonial';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  employeeName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Image>;
  /** Maximum 250 characters */
  testimonal?: Maybe<Scalars['String']>;
};

export type UkEmployeeTestimonialFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  employeeName?: InputMaybe<StringFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  profilePicture?: InputMaybe<ImageFilter>;
  testimonal?: InputMaybe<StringFilter>;
};

export type UkEmployeeTestimonialSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  employeeName?: InputMaybe<SortOrder>;
  jobTitle?: InputMaybe<SortOrder>;
  profilePicture?: InputMaybe<ImageSorting>;
  testimonal?: InputMaybe<SortOrder>;
};

export type UkFdprinciple = Document & {
  __typename?: 'UkFdprinciple';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fdPrinciple?: Maybe<Scalars['String']>;
};

export type UkFdprincipleFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  fdPrinciple?: InputMaybe<StringFilter>;
};

export type UkFdprincipleSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  fdPrinciple?: InputMaybe<SortOrder>;
};

export type UkInterviewStep = Document & {
  __typename?: 'UkInterviewStep';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  step?: Maybe<Scalars['String']>;
};

export type UkInterviewStepFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  step?: InputMaybe<StringFilter>;
};

export type UkInterviewStepSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  step?: InputMaybe<SortOrder>;
};

export type UkLocationIcon = Document & {
  __typename?: 'UkLocationIcon';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Image>;
  location?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type UkLocationIconFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  image?: InputMaybe<ImageFilter>;
  location?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type UkLocationIconSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  location?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type UkMenu = Document & {
  __typename?: 'UkMenu';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  menuItems?: Maybe<Array<Maybe<UkMenuItem>>>;
  name?: Maybe<Scalars['String']>;
};

export type UkMenuFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  name?: InputMaybe<StringFilter>;
};

export type UkMenuItem = {
  __typename?: 'UkMenuItem';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  newWindow?: Maybe<Scalars['Boolean']>;
};

export type UkMenuItemFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  newWindow?: InputMaybe<BooleanFilter>;
};

export type UkMenuItemSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  newWindow?: InputMaybe<SortOrder>;
};

export type UkMenuSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type UkMetric = {
  __typename?: 'UkMetric';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  metricName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UkMetricFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
  metricName?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type UkMetricSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  metricName?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type UkPage = Document & {
  __typename?: 'UkPage';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  careersPageType?: Maybe<Scalars['String']>;
  pageSections?: Maybe<Array<Maybe<UkPageSection>>>;
  pageType?: Maybe<Scalars['String']>;
};

export type UkPageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  careersPageType?: InputMaybe<StringFilter>;
  pageType?: InputMaybe<StringFilter>;
};

export type UkPageSection = Document & {
  __typename?: 'UkPageSection';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  buttonLinks?: Maybe<Array<Maybe<UkButton>>>;
  employeeBenefits?: Maybe<Array<Maybe<UkEmployeeBenefit>>>;
  employeeProfiles?: Maybe<Array<Maybe<UkEmployeeProfile>>>;
  employeeTestimonials?: Maybe<Array<Maybe<UkEmployeeTestimonial>>>;
  fdPrinciples?: Maybe<Array<Maybe<UkFdprinciple>>>;
  fdProducts?: Maybe<Array<Maybe<UkProduct>>>;
  fdProductsOverview?: Maybe<Array<Maybe<UkProduct>>>;
  interviewProcess?: Maybe<Array<Maybe<UkInterviewStep>>>;
  locationIcons?: Maybe<Array<Maybe<UkLocationIcon>>>;
  ourRoles?: Maybe<Array<Maybe<UkCareer>>>;
  progression?: Maybe<Array<Maybe<UkCareer>>>;
  sectionDescriptionRaw?: Maybe<Scalars['JSON']>;
  sectionImages?: Maybe<Array<Maybe<Image>>>;
  sectionTitle?: Maybe<Scalars['String']>;
  sectionType?: Maybe<Scalars['String']>;
};

export type UkPageSectionFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  sectionTitle?: InputMaybe<StringFilter>;
  sectionType?: InputMaybe<StringFilter>;
};

export type UkPageSectionSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  sectionTitle?: InputMaybe<SortOrder>;
  sectionType?: InputMaybe<SortOrder>;
};

export type UkPageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  careersPageType?: InputMaybe<SortOrder>;
  pageType?: InputMaybe<SortOrder>;
};

export type UkProduct = Document & {
  __typename?: 'UkProduct';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']>;
  _key?: Maybe<Scalars['String']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>;
  /** Document type */
  _type?: Maybe<Scalars['String']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>;
  appScreenshot?: Maybe<Image>;
  descriptionRaw?: Maybe<Scalars['JSON']>;
  image?: Maybe<Image>;
  link?: Maybe<Scalars['String']>;
  metrics?: Maybe<Array<Maybe<UkMetric>>>;
  name?: Maybe<Scalars['String']>;
};

export type UkProductFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  appScreenshot?: InputMaybe<ImageFilter>;
  image?: InputMaybe<ImageFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type UkProductSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  appScreenshot?: InputMaybe<ImageSorting>;
  image?: InputMaybe<ImageSorting>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type UkRole = {
  __typename?: 'UkRole';
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
};

export type UkRoleFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  roleName?: InputMaybe<StringFilter>;
};

export type UkRoleSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  roleName?: InputMaybe<SortOrder>;
};

export type GetHomepageQueryVariables = Exact<{
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetHomepageQuery = { __typename?: 'Query', allMkHomePage: Array<{ __typename?: 'MkHomePage', _id?: string | null, mk_header?: string | null, mk_footer?: boolean | null, mk_pageBuilder?: Array<{ __typename?: 'MkCallToAction', _key?: string | null, _type?: string | null, mk_callToAction?: string | null, mk_callToActionLink?: string | null, mk_headingh1?: string | null, mk_topHtml?: string | null, mk_backgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_backgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null, mk_cards?: Array<{ __typename?: 'MkCallToActionCard', mk_headingText?: string | null, mk_topHtml?: string | null, mk_backTextColor?: { __typename?: 'SimplerColor', value?: string | null } | null, bodyTextColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_headingTextColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_sideImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', altText?: string | null, url?: string | null } | null } | null } | null> | null, mk_headingh1Color?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_lineUnderHeaderColor?: { __typename?: 'SimplerColor', value?: string | null } | null, separatorImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', altText?: string | null, url?: string | null } | null } | null } | { __typename?: 'MkCarouselHero', _type?: string | null, title?: string | null, mobileSlideNavUi?: string | null, desktopSlideNavUi?: string | null, mobileIntroVideoUrl?: string | null, desktopIntroVideoUrl?: string | null, moduleAnalyticsEventProperty?: string | null, placementAnalyticsEventProperty?: string | null, slides?: Array<{ __typename?: 'MkCarouselHeroSlide', title?: string | null, isHidden?: boolean | null, productNameAndLogo?: string | null, headlineText?: string | null, sublineHeading?: string | null, sublineDescription?: string | null, buttonOneText?: string | null, buttonOneUrl?: string | null, buttonOneAnalyticsEventName?: string | null, buttonOneProductAnalyticsEventProperty?: string | null, buttonTwoText?: string | null, buttonTwoUrl?: string | null, buttonTwoAnalyticsEventName?: string | null, buttonTwoProductAnalyticsEventProperty?: string | null, mobileBackgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, tabletBackgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, desktopBackgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, customProductNameAndLogoImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, headlineImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null } | null> | null } | { __typename?: 'MkCustomHtmlTemplate', _type?: string | null, mk_html?: string | null } | { __typename?: 'MkCustomJsTemplate', _type?: string | null, mk_js?: string | null } | { __typename?: 'MkHeading', _key?: string | null, _type?: string | null, mk_heading_main?: string | null, mk_heading_id?: string | null, mk_heading_sub?: string | null, mk_heading_mainColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_heading_subColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_BackgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkHero' } | { __typename?: 'MkInfoCardsTemplate', _key?: string | null, _type?: string | null, moduleAnalyticsEventProperty?: string | null, placementAnalyticsEventProperty?: string | null, mk_BackgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_cards?: Array<{ __typename?: 'MkInfoCard', mk_position?: string | null, exploreItemContentMaxWidth?: string | null, mk_grid_span_xsm?: number | null, mk_grid_span_sm?: number | null, mk_grid_span_md?: number | null, mk_grid_span_lg?: number | null, mk_grid_span_xl?: number | null, mk_cardLink?: string | null, cardLinkAnalyticsEventName?: string | null, cardProductAnalyticsEventProperty?: string | null, mk_OverlayOpacity?: number | null, mk_OverlayOpacityColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_picture?: { __typename?: 'SrcSetImage', smSrcSet?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null, lgSrcSet?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', altText?: string | null, url?: string | null } | null } | null } | null, mk_sub_builder_array?: Array<{ __typename?: 'MkSubBody', mk_body?: string | null, _type?: string | null, _key?: string | null, mk_bodyColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkSubBodyContentLove', mk_body?: string | null, _type?: string | null, _key?: string | null, mk_bodyColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkSubBodyHtp', _key?: string | null, _type?: string | null, mk_body?: string | null, mk_bodyColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkSubCta', _key?: string | null, _type?: string | null, mk_callToAction?: string | null, mk_callToActionLink?: string | null, mk_callToActionImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | { __typename?: 'MkSubCtaHtp', _key?: string | null, _type?: string | null, mk_callToActionLink?: string | null, mk_callToAction_text?: string | null, mk_callToActionImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | { __typename?: 'MkSubCtaRectangle', _key?: string | null, _type?: string | null, mk_callToActionLink?: string | null, callToActionLinkAnalyticsEventName?: string | null, mk_callToAction_text?: string | null } | { __typename?: 'MkSubHeader', _key?: string | null, _type?: string | null, mk_HeaderImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null, mk_logoHeaderImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | { __typename?: 'MkSubHeaderLarge', _key?: string | null, _type?: string | null, mk_sub_header_large?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'MkResponsiveBanner', _key?: string | null, _type?: string | null, altText?: string | null, ctaLink?: string | null, moduleAnalyticsEventProperty?: string | null, placementAnalyticsEventProperty?: string | null, desktopImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, mobileImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, tabletImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null } | { __typename?: 'MkSpacer', _type?: string | null, title?: string | null, defaultSpacing?: number | null, spacingBreakpointXsm?: number | null, spacingBreakpointSm?: number | null, spacingBreakpointMd?: number | null, spacingBreakpointLg?: number | null, spacingBreakpointXl?: number | null, spacingBreakpointXxl?: number | null, backgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkWhereCanYouPlayTemplate', _key?: string | null, _type?: string | null, products?: Array<{ __typename?: 'MkProductOptions', _key?: string | null, _type?: string | null, detailsUrl?: string | null, disclaimerText?: string | null, productName?: string | null, availableLocations?: Array<{ __typename?: 'LocationsList', code?: string | null, name?: string | null, subtext?: string | null, tvgOnly?: boolean | null, _key?: string | null, _type?: string | null } | null> | null } | null> | null } | { __typename?: 'MkWhyFanDuelTemplate', _type?: string | null, subtext?: string | null, title?: string | null, whyFanduel?: Array<{ __typename?: 'MkWhyFanDuelCard', _type?: string | null, html?: string | null, title?: string | null } | null> | null } | null> | null, mk_seo?: { __typename?: 'Seo', seoDescription?: string | null, seoTitle?: string | null, noIndex?: boolean | null, canonicalUrl?: string | null, seoKeywords?: string | null, openGraph?: { __typename?: 'OpenGraph', title?: string | null, type?: string | null, image?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null } | null } | null }> };

export type GetHomepageCmsAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomepageCmsAttributesQuery = { __typename?: 'Query', allMkHomePage: Array<{ __typename?: 'MkHomePage', _updatedAt?: any | null }> };

export type GetIndexablePagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndexablePagesQuery = { __typename?: 'Query', allMkMarketingPage: Array<{ __typename?: 'MkMarketingPage', _id?: string | null, _updatedAt?: any | null, mk_slug?: { __typename?: 'Slug', current?: string | null } | null }> };

export type GetPageQueryVariables = Exact<{
  mk_slug?: InputMaybe<Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPageQuery = { __typename?: 'Query', allMkMarketingPage: Array<{ __typename?: 'MkMarketingPage', _id?: string | null, mk_header?: string | null, mk_footer?: boolean | null, mk_pageNameAnalyticsEventProperty?: string | null, mk_slug?: { __typename?: 'Slug', current?: string | null } | null, mk_pageBuilder?: Array<{ __typename?: 'MkCallToAction', _key?: string | null, _type?: string | null, mk_callToAction?: string | null, mk_callToActionLink?: string | null, mk_headingh1?: string | null, mk_topHtml?: string | null, mk_backgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_backgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null, mk_cards?: Array<{ __typename?: 'MkCallToActionCard', mk_headingText?: string | null, mk_topHtml?: string | null, mk_backTextColor?: { __typename?: 'SimplerColor', value?: string | null } | null, bodyTextColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_headingTextColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_sideImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', altText?: string | null, url?: string | null } | null } | null } | null> | null, mk_headingh1Color?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_lineUnderHeaderColor?: { __typename?: 'SimplerColor', value?: string | null } | null, separatorImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', altText?: string | null, url?: string | null } | null } | null } | { __typename?: 'MkCarouselHero', _type?: string | null, title?: string | null, mobileSlideNavUi?: string | null, desktopSlideNavUi?: string | null, mobileIntroVideoUrl?: string | null, desktopIntroVideoUrl?: string | null, moduleAnalyticsEventProperty?: string | null, placementAnalyticsEventProperty?: string | null, slides?: Array<{ __typename?: 'MkCarouselHeroSlide', title?: string | null, isHidden?: boolean | null, productNameAndLogo?: string | null, headlineText?: string | null, sublineHeading?: string | null, sublineDescription?: string | null, buttonOneText?: string | null, buttonOneUrl?: string | null, buttonOneAnalyticsEventName?: string | null, buttonOneProductAnalyticsEventProperty?: string | null, buttonTwoText?: string | null, buttonTwoUrl?: string | null, buttonTwoAnalyticsEventName?: string | null, buttonTwoProductAnalyticsEventProperty?: string | null, mobileBackgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, tabletBackgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, desktopBackgroundImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, customProductNameAndLogoImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, headlineImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null } | null> | null } | { __typename?: 'MkCustomHtmlTemplate', _type?: string | null, mk_html?: string | null } | { __typename?: 'MkCustomJsTemplate', _type?: string | null, mk_js?: string | null } | { __typename?: 'MkHeading', _key?: string | null, _type?: string | null, mk_heading_main?: string | null, mk_heading_id?: string | null, mk_heading_sub?: string | null, mk_heading_mainColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_heading_subColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_BackgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkHero' } | { __typename?: 'MkInfoCardsTemplate', _key?: string | null, _type?: string | null, moduleAnalyticsEventProperty?: string | null, placementAnalyticsEventProperty?: string | null, mk_BackgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_cards?: Array<{ __typename?: 'MkInfoCard', mk_position?: string | null, exploreItemContentMaxWidth?: string | null, mk_grid_span_xsm?: number | null, mk_grid_span_sm?: number | null, mk_grid_span_md?: number | null, mk_grid_span_lg?: number | null, mk_grid_span_xl?: number | null, mk_cardLink?: string | null, cardLinkAnalyticsEventName?: string | null, cardProductAnalyticsEventProperty?: string | null, mk_OverlayOpacity?: number | null, mk_OverlayOpacityColor?: { __typename?: 'SimplerColor', value?: string | null } | null, mk_picture?: { __typename?: 'SrcSetImage', smSrcSet?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null, lgSrcSet?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', altText?: string | null, url?: string | null } | null } | null } | null, mk_sub_builder_array?: Array<{ __typename?: 'MkSubBody', mk_body?: string | null, _type?: string | null, _key?: string | null, mk_bodyColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkSubBodyContentLove', mk_body?: string | null, _type?: string | null, _key?: string | null, mk_bodyColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkSubBodyHtp', _key?: string | null, _type?: string | null, mk_body?: string | null, mk_bodyColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkSubCta', _key?: string | null, _type?: string | null, mk_callToAction?: string | null, mk_callToActionLink?: string | null, mk_callToActionImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | { __typename?: 'MkSubCtaHtp', _key?: string | null, _type?: string | null, mk_callToActionLink?: string | null, mk_callToAction_text?: string | null, mk_callToActionImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | { __typename?: 'MkSubCtaRectangle', _key?: string | null, _type?: string | null, mk_callToActionLink?: string | null, callToActionLinkAnalyticsEventName?: string | null, mk_callToAction_text?: string | null } | { __typename?: 'MkSubHeader', _key?: string | null, _type?: string | null, mk_HeaderImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null, mk_logoHeaderImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | { __typename?: 'MkSubHeaderLarge', _key?: string | null, _type?: string | null, mk_sub_header_large?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null, altText?: string | null } | null } | null } | null> | null } | null> | null } | { __typename?: 'MkResponsiveBanner', _key?: string | null, _type?: string | null, altText?: string | null, ctaLink?: string | null, moduleAnalyticsEventProperty?: string | null, placementAnalyticsEventProperty?: string | null, desktopImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, mobileImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null, tabletImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null } | { __typename?: 'MkSpacer', _type?: string | null, title?: string | null, defaultSpacing?: number | null, spacingBreakpointXsm?: number | null, spacingBreakpointSm?: number | null, spacingBreakpointMd?: number | null, spacingBreakpointLg?: number | null, spacingBreakpointXl?: number | null, spacingBreakpointXxl?: number | null, backgroundColor?: { __typename?: 'SimplerColor', value?: string | null } | null } | { __typename?: 'MkWhereCanYouPlayTemplate', _key?: string | null, _type?: string | null, products?: Array<{ __typename?: 'MkProductOptions', _key?: string | null, _type?: string | null, detailsUrl?: string | null, disclaimerText?: string | null, productName?: string | null, availableLocations?: Array<{ __typename?: 'LocationsList', code?: string | null, name?: string | null, subtext?: string | null, tvgOnly?: boolean | null, _key?: string | null, _type?: string | null } | null> | null } | null> | null } | { __typename?: 'MkWhyFanDuelTemplate', _type?: string | null, subtext?: string | null, title?: string | null, whyFanduel?: Array<{ __typename?: 'MkWhyFanDuelCard', _type?: string | null, html?: string | null, title?: string | null } | null> | null } | null> | null, mk_seo?: { __typename?: 'Seo', seoDescription?: string | null, seoTitle?: string | null, noIndex?: boolean | null, canonicalUrl?: string | null, seoKeywords?: string | null, openGraph?: { __typename?: 'OpenGraph', title?: string | null, type?: string | null, image?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', url?: string | null } | null } | null } | null } | null }> };

export type GetPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPagesQuery = { __typename?: 'Query', allMkMarketingPage: Array<{ __typename?: 'MkMarketingPage', _id?: string | null, _updatedAt?: any | null, mk_slug?: { __typename?: 'Slug', current?: string | null } | null }> };

export type GetRedirectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedirectsQuery = { __typename?: 'Query', allMkRedirect: Array<{ __typename?: 'MkRedirect', mk_old_path?: string | null, mk_new_path?: string | null }> };


export const GetHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMkHomePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_draft"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"mk_header"}},{"kind":"Field","name":{"kind":"Name","value":"mk_footer"}},{"kind":"Field","name":{"kind":"Name","value":"mk_pageBuilder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCustomHtmlTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_html"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCustomJsTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_js"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkWhyFanDuelTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"subtext"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"whyFanduel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkWhereCanYouPlayTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"detailsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimerText"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"availableLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtext"}},{"kind":"Field","name":{"kind":"Name","value":"tvgOnly"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkHeading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_main"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_id"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_mainColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_sub"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_subColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_BackgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSpacer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointXsm"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointSm"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointMd"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointLg"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointXl"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointXxl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCarouselHero"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSlideNavUi"}},{"kind":"Field","name":{"kind":"Name","value":"desktopSlideNavUi"}},{"kind":"Field","name":{"kind":"Name","value":"mobileIntroVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"desktopIntroVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moduleAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"placementAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"slides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"mobileBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabletBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productNameAndLogo"}},{"kind":"Field","name":{"kind":"Name","value":"customProductNameAndLogoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"headlineImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"headlineText"}},{"kind":"Field","name":{"kind":"Name","value":"sublineHeading"}},{"kind":"Field","name":{"kind":"Name","value":"sublineDescription"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneProductAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoProductAnalyticsEventProperty"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCallToAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction"}},{"kind":"Field","name":{"kind":"Name","value":"mk_backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"mk_cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_backTextColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bodyTextColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingText"}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingTextColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_sideImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_topHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingh1"}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingh1Color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_lineUnderHeaderColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_topHtml"}},{"kind":"Field","name":{"kind":"Name","value":"separatorImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkResponsiveBanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLink"}},{"kind":"Field","name":{"kind":"Name","value":"desktopImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"moduleAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"placementAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"tabletImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkInfoCardsTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"moduleAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"placementAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"mk_BackgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_position"}},{"kind":"Field","name":{"kind":"Name","value":"exploreItemContentMaxWidth"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_xsm"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_sm"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_md"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_lg"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_xl"}},{"kind":"Field","name":{"kind":"Name","value":"mk_cardLink"}},{"kind":"Field","name":{"kind":"Name","value":"cardLinkAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"cardProductAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"mk_OverlayOpacity"}},{"kind":"Field","name":{"kind":"Name","value":"mk_OverlayOpacityColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smSrcSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lgSrcSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_sub_builder_array"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_body"}},{"kind":"Field","name":{"kind":"Name","value":"mk_bodyColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubBodyContentLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_body"}},{"kind":"Field","name":{"kind":"Name","value":"mk_bodyColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubCta"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubHeaderLarge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_sub_header_large"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubCtaRectangle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"callToActionLinkAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction_text"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubCtaHtp"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction_text"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubBodyHtp"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_body"}},{"kind":"Field","name":{"kind":"Name","value":"mk_bodyColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubHeader"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_HeaderImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_logoHeaderImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"noIndex"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"openGraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetHomepageQuery, GetHomepageQueryVariables>;
export const GetHomepageCmsAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHomepageCmsAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMkHomePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_draft"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetHomepageCmsAttributesQuery, GetHomepageCmsAttributesQueryVariables>;
export const GetIndexablePagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndexablePages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMkMarketingPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mk_seo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"noIndex"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_draft"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"mk_slug"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetIndexablePagesQuery, GetIndexablePagesQueryVariables>;
export const GetPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mk_slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMkMarketingPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mk_slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"current"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mk_slug"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_draft"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"mk_slug"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_header"}},{"kind":"Field","name":{"kind":"Name","value":"mk_footer"}},{"kind":"Field","name":{"kind":"Name","value":"mk_pageNameAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"mk_pageBuilder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCustomHtmlTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_html"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCustomJsTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_js"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkWhyFanDuelTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"subtext"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"whyFanduel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkWhereCanYouPlayTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"detailsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimerText"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"availableLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subtext"}},{"kind":"Field","name":{"kind":"Name","value":"tvgOnly"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkHeading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_main"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_id"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_mainColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_sub"}},{"kind":"Field","name":{"kind":"Name","value":"mk_heading_subColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_BackgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSpacer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointXsm"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointSm"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointMd"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointLg"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointXl"}},{"kind":"Field","name":{"kind":"Name","value":"spacingBreakpointXxl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCarouselHero"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mobileSlideNavUi"}},{"kind":"Field","name":{"kind":"Name","value":"desktopSlideNavUi"}},{"kind":"Field","name":{"kind":"Name","value":"mobileIntroVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"desktopIntroVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moduleAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"placementAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"slides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"mobileBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tabletBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopBackgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productNameAndLogo"}},{"kind":"Field","name":{"kind":"Name","value":"customProductNameAndLogoImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"headlineImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"headlineText"}},{"kind":"Field","name":{"kind":"Name","value":"sublineHeading"}},{"kind":"Field","name":{"kind":"Name","value":"sublineDescription"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneProductAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTwoProductAnalyticsEventProperty"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkCallToAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction"}},{"kind":"Field","name":{"kind":"Name","value":"mk_backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"mk_cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_backTextColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bodyTextColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingText"}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingTextColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_sideImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_topHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingh1"}},{"kind":"Field","name":{"kind":"Name","value":"mk_headingh1Color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_lineUnderHeaderColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_topHtml"}},{"kind":"Field","name":{"kind":"Name","value":"separatorImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkResponsiveBanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLink"}},{"kind":"Field","name":{"kind":"Name","value":"desktopImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"moduleAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"placementAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"tabletImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkInfoCardsTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"moduleAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"placementAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"mk_BackgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_position"}},{"kind":"Field","name":{"kind":"Name","value":"exploreItemContentMaxWidth"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_xsm"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_sm"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_md"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_lg"}},{"kind":"Field","name":{"kind":"Name","value":"mk_grid_span_xl"}},{"kind":"Field","name":{"kind":"Name","value":"mk_cardLink"}},{"kind":"Field","name":{"kind":"Name","value":"cardLinkAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"cardProductAnalyticsEventProperty"}},{"kind":"Field","name":{"kind":"Name","value":"mk_OverlayOpacity"}},{"kind":"Field","name":{"kind":"Name","value":"mk_OverlayOpacityColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smSrcSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lgSrcSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_sub_builder_array"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_body"}},{"kind":"Field","name":{"kind":"Name","value":"mk_bodyColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubBodyContentLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_body"}},{"kind":"Field","name":{"kind":"Name","value":"mk_bodyColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubCta"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubHeaderLarge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_sub_header_large"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubCtaRectangle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"callToActionLinkAnalyticsEventName"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction_text"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubCtaHtp"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToActionLink"}},{"kind":"Field","name":{"kind":"Name","value":"mk_callToAction_text"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubBodyHtp"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"mk_body"}},{"kind":"Field","name":{"kind":"Name","value":"mk_bodyColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_type"}},{"kind":"Field","name":{"kind":"Name","value":"_key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MkSubHeader"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_HeaderImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_logoHeaderImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_key"}},{"kind":"Field","name":{"kind":"Name","value":"_type"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mk_seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"noIndex"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"openGraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPageQuery, GetPageQueryVariables>;
export const GetPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMkMarketingPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_draft"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"mk_slug"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetPagesQuery, GetPagesQueryVariables>;
export const GetRedirectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRedirects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allMkRedirect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mk_enabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_draft"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mk_old_path"}},{"kind":"Field","name":{"kind":"Name","value":"mk_new_path"}}]}}]}}]} as unknown as DocumentNode<GetRedirectsQuery, GetRedirectsQueryVariables>;